import React from 'react';
import logo from '../assets/logo-narayan.png';

// A professional, downloadable staff identity card.
// Uses inline styles throughout so html2canvas rasterises it faithfully.
const S = {
  card: { width: 320, background: '#fff', borderRadius: 20, overflow: 'hidden', border: '1px solid #ECEDF2' },
  header: { background: '#C1121F', padding: '16px 16px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  logoChip: { background: '#fff', padding: '8px 12px', borderRadius: 999, display: 'inline-flex' },
  title: { color: '#fff', fontSize: 12, fontWeight: 800, letterSpacing: 3, marginTop: 12 },
  band: { height: 6, background: '#E8A33D' },
  body: { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 20px 12px' },
  photo: { width: 116, height: 138, borderRadius: 12, border: '3px solid #fff', background: '#F6F7FB', objectFit: 'cover', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 40 },
  verified: { background: '#1E9E6A', color: '#fff', padding: '4px 12px', borderRadius: 999, fontSize: 10.5, fontWeight: 800, letterSpacing: 1, marginTop: -12, position: 'relative' },
  name: { fontSize: 21, fontWeight: 800, color: '#1B1D28', marginTop: 14, textAlign: 'center' },
  role: { fontSize: 13, color: '#6B6F80', marginTop: 2, textAlign: 'center' },
  idPill: { display: 'flex', alignItems: 'center', background: '#FDECEE', borderRadius: 999, padding: '6px 8px', marginTop: 14 },
  idLabel: { background: '#C1121F', color: '#fff', fontSize: 11, fontWeight: 800, padding: '2px 8px', borderRadius: 999 },
  idValue: { color: '#C1121F', fontSize: 17, fontWeight: 800, letterSpacing: 1, margin: '0 6px 0 10px' },
  metaRow: { display: 'flex', gap: 28, marginTop: 16 },
  metaLabel: { fontSize: 9.5, color: '#9AA0B0', fontWeight: 700, letterSpacing: 1, textAlign: 'center' },
  metaValue: { fontSize: 13, color: '#1B1D28', fontWeight: 700, marginTop: 2, textAlign: 'center' },
  footer: { background: '#2B0A0D', padding: '12px 16px', textAlign: 'center' },
  footerBrand: { color: '#fff', fontSize: 12.5, fontWeight: 800 },
  footerNote: { color: 'rgba(255,255,255,0.7)', fontSize: 9.5, marginTop: 3 },
};

export default function IdCard({ user, cardRef }) {
  const photo = user?.profilePhoto || user?.kyc?.selfieImage;
  const skills = (user?.skills || []).slice(0, 2).join(' · ') || 'Home Facility Services';
  const issued = new Date().getFullYear();

  return (
    <div ref={cardRef} style={S.card}>
      <div style={S.header}>
        <span style={S.logoChip}><img src={logo} alt="" style={{ height: 30 }} /></span>
        <div style={S.title}>STAFF IDENTITY CARD</div>
      </div>

      <div style={S.band} />

      <div style={S.body}>
        {photo ? (
          <img src={photo} alt={user?.name || 'Staff'} style={S.photo} crossOrigin="anonymous" />
        ) : (
          <div style={{ ...S.photo, borderColor: '#ECEDF2' }}>👤</div>
        )}
        <div style={S.verified}>✓ VERIFIED</div>

        <div style={S.name}>{user?.name || 'Staff Member'}</div>
        <div style={S.role}>{skills}</div>

        <div style={S.idPill}>
          <span style={S.idLabel}>ID</span>
          <span style={S.idValue}>{user?.staffId || 'NRN-—'}</span>
        </div>

        <div style={S.metaRow}>
          <div>
            <div style={S.metaLabel}>MOBILE</div>
            <div style={S.metaValue}>+91 {user?.mobile || '—'}</div>
          </div>
          <div>
            <div style={S.metaLabel}>ISSUED</div>
            <div style={S.metaValue}>{issued}</div>
          </div>
        </div>
      </div>

      <div style={S.footer}>
        <div style={S.footerBrand}>Narayan Home Facility Services</div>
        <div style={S.footerNote}>This card certifies the holder is a KYC-verified service provider.</div>
      </div>
    </div>
  );
}
